import { render, staticRenderFns } from "./candidate-page.vue?vue&type=template&id=de5cafd6&scoped=true"
import script from "./candidate-page.vue?vue&type=script&lang=js"
export * from "./candidate-page.vue?vue&type=script&lang=js"
import style0 from "./candidate-page.vue?vue&type=style&index=0&id=de5cafd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5cafd6",
  null
  
)

export default component.exports